import { render } from "./subjectchart.vue?vue&type=template&id=85de2160"
import script from "./subjectchart.vue?vue&type=script&lang=js"
export * from "./subjectchart.vue?vue&type=script&lang=js"

import "./subjectchart.vue?vue&type=style&index=0&id=85de2160&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__